import { useCallback, useEffect, useState } from 'react'

const STORAGE_KEY = 'admin_sidebar_collapsed'

function readInitial(): boolean {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY)
    return stored === 'true'
  } catch {
    return false
  }
}

export function useSidebarCollapsed(): [boolean, (next: boolean) => void, () => void] {
  const [collapsed, setCollapsedState] = useState<boolean>(readInitial)

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, collapsed ? 'true' : 'false')
    } catch {
      // localStorage unavailable - non-fatal
    }
  }, [collapsed])

  const setCollapsed = useCallback((next: boolean) => {
    setCollapsedState(next)
  }, [])

  const toggle = useCallback(() => {
    setCollapsedState(prev => !prev)
  }, [])

  return [collapsed, setCollapsed, toggle]
}
